import { render } from "./PlaytronPageTest.vue?vue&type=template&id=3b5fbef2&scoped=true&class=row"
import script from "./PlaytronPageTest.vue?vue&type=script&lang=js"
export * from "./PlaytronPageTest.vue?vue&type=script&lang=js"

import "./PlaytronPageTest.vue?vue&type=style&index=0&id=3b5fbef2&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5fbef2"]])

export default __exports__